import { SelectedSocialProfileValue } from 'components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { ErrorMessageSeverity } from 'constants/form';

export type AnalyticsNavbarState = {
  appliedStartDateOverview: Date;
  appliedEndDateOverview: Date;
  appliedStartDateByProfileView: Date;
  appliedEndDateByProfileView: Date;
  appliedProfileIdsOverview: string[];
  appliedProfileId: string;
  selectedProfilesOverview: SelectedSocialProfileValue[];
  selectedProfileId: string | undefined;
  profileErrorStateOverview: { errorSeverity: ErrorMessageSeverity; message: string } | null;
  profileErrorState: { errorSeverity: ErrorMessageSeverity; message: string } | null;
};

type Action =
  | { type: 'APPLY_FILTERS_OVERVIEW'; payload: { profilesIds: string[]; startDate: Date; endDate: Date } }
  | { type: 'APPLY_FILTERS_PROFILE'; payload: { profileId: string; startDate: Date; endDate: Date } }
  | { type: 'SET_SELECTED_PROFILES_OVERVIEW'; payload: SelectedSocialProfileValue[] }
  | { type: 'SET_SELECTED_PROFILE_ID'; payload: string | undefined }
  | { type: 'SET_UNIQUE_PROFILE'; payload: string | undefined }
  | { type: 'SET_PROFILE_ERROR_OVERVIEW'; payload: { errorSeverity: ErrorMessageSeverity; message: string } | null }
  | { type: 'SET_PROFILE_ERROR'; payload: { errorSeverity: ErrorMessageSeverity; message: string } | null };

export const AnalyticsNavbarReducer = (state: AnalyticsNavbarState, action: Action) => {
  switch (action.type) {
    case 'APPLY_FILTERS_OVERVIEW':
      return {
        ...state,
        appliedProfileIdsOverview: action.payload.profilesIds,
        appliedStartDateOverview: action.payload.startDate,
        appliedEndDateOverview: action.payload.endDate
      };

    case 'APPLY_FILTERS_PROFILE':
      return {
        ...state,
        appliedStartDateByProfileView: action.payload.startDate,
        appliedEndDateByProfileView: action.payload.endDate,
        appliedProfileId: action.payload.profileId
      };

    case 'SET_SELECTED_PROFILES_OVERVIEW':
      return {
        ...state,
        selectedProfilesOverview: action.payload
      };

    case 'SET_SELECTED_PROFILE_ID':
      return {
        ...state,
        selectedProfileId: action.payload
      };

    case 'SET_PROFILE_ERROR_OVERVIEW':
      return {
        ...state,
        profileErrorStateOverview: action.payload
      };

    case 'SET_PROFILE_ERROR':
      return {
        ...state,
        profileErrorState: action.payload
      };
    case 'SET_UNIQUE_PROFILE':
      return {
        ...state,
        profileErrorState: null,
        selectedProfileId: action.payload
      };

    default:
      return state;
  }
};
